export const EditQuestionActionTypes = {
    TOGGLE_EDIT_QUESTION_PAGE: 'TOGGLE_QUESTION_PAGE'
};